export const ContentTypes = {
  components: {
    button: 'componentButton',
    link: 'componentLink',
    video: 'componentVideo',
  },
  hero: {
    comparisonDynamic: 'comparisonPageHero',
    enterprise: 'enterprisePageHero',
    pricing: 'pricingPageHero',
    text: 'heroText',
    textWithVideo: 'heroTextWithVideo',
  },
  page: 'page',
  sections: {
    shared: {
      blogPosts: 'sectionBlogPosts',
      blurbs: 'sectionBlurbs',
      brands: 'sectionBrands',
      callToAction: 'commonCallToAction',
      customerQuote: 'commonCustomer',
      customers: 'sectionCustomers',
      group: 'sectionGroup',
      pageCards: 'sectionPageCards',
      questions: 'sectionQuestions',
      tagline: 'sectionTagline',
      text: 'sectionText',
      textWithAssets: 'sectionTextWithAssets',
      textWithImage: 'sectionTextWithImage',
      textWithMultipleImages: 'sectionTextWithMultipleImages',
      textWithTimeline: 'sectionTextWithTimeline',
    },
    legal: {
      text: 'sectionLegalText',
    },
    pricing: {
      oldFaq: 'pricingPageFaq',
      oldFeatureComparison: 'pricingPageFeatureComparison',
    },
    productTour: {
      generic: 'productTourGeneric',
      references: 'productTourReference',
      tools: 'productTourTools',
    },
    about: {
      distributedTeam: 'aboutPageDistributedTeam',
      summary: 'aboutPageSummary',
    },
    comparison: {
      generic: 'comparisonPageGeneric',
    },
    home: {
      brands: 'homePageBrands',
      customer: 'commonCustomer',
      generic: 'homePageGeneric',
      productTour: 'homePageProductTour',
      productOverview: 'homePageProductOverview',
    },
  },
};
